import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const carIcon = L.divIcon({
  className: "custom-car-marker",
  html: `<div style="background:#E5A93C;width:32px;height:32px;border-radius:50%;display:grid;place-items:center;border:3px solid #090D14;box-shadow:0 0 20px rgba(229,169,60,0.6);color:#090D14;font-size:16px;font-weight:900">🚗</div>`,
  iconSize: [32, 32], iconAnchor: [16, 16],
});

export default function LiveMap({ lat, lng, driverName, vehicle, plate }) {
  const center = lat && lng ? [lat, lng] : [-36.8485, 174.7633]; // Auckland fallback
  return (
    <div className="rounded-2xl overflow-hidden border border-amber-400/30" style={{ height: 320 }}>
      <MapContainer center={center} zoom={14} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{y}/{x}.png"
        />
        {lat && lng && (
          <Marker position={[lat, lng]} icon={carIcon}>
            <Popup><b>{driverName}</b><br />{vehicle}<br /><span style={{ fontFamily: "monospace" }}>{plate}</span></Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
}
